import { RuleIds } from "../../models/KnxRule";

import mdtButton_mapSignalToTag from "./Rules/MDT/mapSignalToTag.js?raw";
import mertenButton_mapSignalToTag from "./Rules/Merten/mapSignalToTag.js?raw";
import jungButton_mapSignalToTag from "./Rules/Jung/mapSignalToTag.js?raw";
import genericButton_mapSignalToTag from "./Rules/Generic/mapSignalToTag.js?raw";

const MDT_Rules = {
  [RuleIds.mapSignalToTag]: mdtButton_mapSignalToTag,
};

const Fallback_Rules = {
  [RuleIds.mapSignalToTag]: genericButton_mapSignalToTag,
};

const Jung_Rules = {
  [RuleIds.mapSignalToTag]: jungButton_mapSignalToTag,
};

const Merten_Rules = {
  [RuleIds.mapSignalToTag]: mertenButton_mapSignalToTag,
};

const ManufacturerButtonRules = {
  ["M-0083"]: MDT_Rules,
  ["M-0004"]: Jung_Rules,
  ["M-000C"]: Merten_Rules,
  ["M-0064"]: Merten_Rules, // no itx
  ["M-xxxx"]: Fallback_Rules,
};

export default ManufacturerButtonRules;
